import * as React from 'react';
import { Field } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import Checkbox from 'af-fields/Checkbox';
import Input from 'af-fields/Input';

import JobUpsertFM from '../../formModel';
import { formSectionClass, formSectionClassColumn2, formSectionClassColumn4, formSectionClassRow } from '../../helpers';
import styles from '../../styles.module.scss';

interface OwnProps {
	isDisabled: boolean;
}

type Props = OwnProps;

const SafetySection: React.FC<Props> = (props) => {
	const { isDisabled } = props;
	const checkboxStyle = React.useMemo(() => [formSectionClassColumn2, styles['job-form__tab-content__form-section__row__centered-column']].join(' '), []);

	return (
		<div className={formSectionClass}>
			<SegmentLabel
				label="Safety"
				tooltip="All identified safety hazards and associated descriptions relevant to this job, covering environmental, physical, mechanical, and biological risks that must be assessed prior to execution."
			/>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="environmentalExposure"
						isDisabled={isDisabled}
						label="Environmental Exposure"
						name={JobUpsertFM.getAttributeName('environmentalExposure')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="environmentalExposureDescription"
						label="Description"
						name={JobUpsertFM.getAttributeName('environmentalExposureDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="respiratoryProtection"
						isDisabled={isDisabled}
						label="Respiratory Protection"
						name={JobUpsertFM.getAttributeName('respiratoryProtection')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="respiratoryProtectionDescription"
						label="Description"
						name={JobUpsertFM.getAttributeName('respiratoryProtectionDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="overheadHazards"
						isDisabled={isDisabled}
						label="Overhead Hazards"
						name={JobUpsertFM.getAttributeName('overheadHazards')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="overheadHazardsDescription"
						label="Description"
						name={JobUpsertFM.getAttributeName('overheadHazardsDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="heightWork"
						isDisabled={isDisabled}
						label="Height Work"
						name={JobUpsertFM.getAttributeName('heightWork')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="heightWorkDescription"
						label="Description"
						name={JobUpsertFM.getAttributeName('heightWorkDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="mechanicalHazards"
						isDisabled={isDisabled}
						label="Mechanical Hazards"
						name={JobUpsertFM.getAttributeName('mechanicalHazards')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="mechanicalHazardsDescription"
						label="Description"
						name={JobUpsertFM.getAttributeName('mechanicalHazardsDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="electricalHazards"
						isDisabled={isDisabled}
						label="Electrical Hazards"
						name={JobUpsertFM.getAttributeName('electricalHazards')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="electricalHazardsDescription"
						label="Description"
						name={JobUpsertFM.getAttributeName('electricalHazardsDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="hazardousMaterials"
						isDisabled={isDisabled}
						label="Hazardous Materials"
						name={JobUpsertFM.getAttributeName('hazardousMaterials')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="hazardousMaterialsDescription"
						label="Description"
						name={JobUpsertFM.getAttributeName('hazardousMaterialsDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="dangerousAnimalsOrPlants"
						isDisabled={isDisabled}
						label="Dangerous Animals or Plants"
						name={JobUpsertFM.getAttributeName('dangerousAnimalsOrPlants')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						disabled={isDisabled}
						id="dangerousAnimalsOrPlantsDescription"
						label="Description"
						name={JobUpsertFM.getAttributeName('dangerousAnimalsOrPlantsDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
		</div>
	);
};

export default React.memo(SafetySection);
